import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import './Header.css';

const Header = () => {
  const { user, logoutUser } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const pathTitle = {
    '/': 'Dashboard',
    '/clienti': 'Clienti',
    '/contracte': 'Contracte',
    '/monitorizare': 'Monitorizare',
    '/ruleaza-monitoring': 'Rulează monitoring',
    '/monitorizare/run': 'Rulează monitoring',
  };

  const title = pathTitle[location.pathname] || 'Dashboard';

  return (
    <header className="header">
      <div>
        <p className="header-kicker">Welcome</p>
        <h1 className="header-title">{user?.first_name} {user?.last_name || 'User'}</h1>
      </div>

    </header>
  );
};

export default Header;